import { LICENSE_TYPES } from "features/MySubscriptions/constants/MySubscriptions.constants";
import { useOpenAccessTypePurchaseModal } from "features/MySubscriptions/hooks/useOpenAccessTypePurchaseModal";
import { OMNICHANNEL_PLANS_MODAL_TITLE } from "../constants/omnichannelPlanModal.constants";

export const useOpenOmnichannelPurchaseModal = () => {
  const { openAccessTypePurchaseModal, isOpeningAccessTypePlans } =
    useOpenAccessTypePurchaseModal(LICENSE_TYPES.CRM_OMNICHANNEL, {
      modalTitle: OMNICHANNEL_PLANS_MODAL_TITLE,
    });

  return {
    openOmnichannelPurchaseModal: openAccessTypePurchaseModal,
    isOpeningAccessTypePlans,
  };
};
